import { h } from 'vue'
import { RouterLink } from 'vue-router'
import { withLang } from '@/i18n'

/**
 * `<router-link>` that keeps the current language prefix.
 *
 * Every page lives under /uz, /ru or /en, but the ~40 links across the site are
 * written as plain absolute paths (`to="/axborot/yangiliklar"`). Rather than
 * rewriting each one — and having to remember the rule in every future link —
 * this wrapper is registered globally under the name `RouterLink`, so the
 * existing markup keeps working and always resolves within the language the
 * reader is currently in.
 *
 * Only absolute string paths are rewritten. A named target ({ name: … }) or a
 * relative path is passed through untouched: the router resolves those against
 * the current (already prefixed) route on its own.
 */
const LocalizedLink = (_props, { attrs, slots }) =>
  h(
    RouterLink,
    { ...attrs, to: typeof attrs.to === 'string' && attrs.to.startsWith('/') ? withLang(attrs.to) : attrs.to },
    slots
  )

// Attributes are forwarded by hand above; letting Vue also apply them to the
// root would set `to` twice, with the un-prefixed value winning.
LocalizedLink.inheritAttrs = false

export default LocalizedLink
